<h3>SAMSON AKTIENGESELLSCHAFT</h3>
<p>
Weismüllerstraße 3<br>
60314 Frankfurt am Main<br>
Postfach 10 19 01<br>
60019 Frankfurt am Main<br><br>
{{TR "Telefon"}}: 069 4009 -0<br>
{{TR "Telefax"}}: 069 4009 -1507<br>
{{TR "Website"}}: <a href="https://www.samsongroup.com/" target="_blank">https://www.samsongroup.com/</a>
</p>

<p>{{TR "E-Mail"}}: <a href="mailto:samson@samsongroup.com">samson@samsongroup.com</a></p>

<p>{{TR "Sitz der Gesellschaft"}}: Frankfurt am Main</p>

<p>{{TR "Registergericht"}}: Amtsgericht Frankfurt am Main, Nr. HRB 7131<br>
{{TR "USt-IdNr"}}: DE 114 208 670<br>
{{TR "WEEE-Reg.-Nr"}}: DE 621 944 39<br></p>

<h4 class="m-t-20">{{TR "Vorstand"}}</h4>
<p>
Dr. Andreas Widl (CEO)<br>
Dr. Dominic Deller (CFO)<br>
Marcus Miertz (CSO)<br>
Norbert Tollas (COO)
</p>

<h4 class="m-t-20">{{TR "Vorsitzender des Aufsichtsrates"}}</h4>
<p>
Dr. Nikolaus Hensel<br>
</p>
